/* DesertDepthCraft — theme.js */

(function () {
  'use strict';

  /* ── Mobile nav ── */
  const mobileNav     = document.getElementById('mobile-nav');
  const overlay       = document.querySelector('.mobile-nav-overlay');
  const openTriggers  = document.querySelectorAll('[data-action="open-menu"]');
  const closeTriggers = document.querySelectorAll('[data-action="close-menu"]');

  function openMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  openTriggers.forEach(el  => el.addEventListener('click', openMenu));
  closeTriggers.forEach(el => el.addEventListener('click', closeMenu));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });

  /* ── Sticky header shrink ── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Lazy-load intersection observer ── */
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-loaded');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '100px' });
    lazyImages.forEach(img => observer.observe(img));
  }

  /* ── Scroll-reveal ── */
  if ('IntersectionObserver' in window) {
    const reveals = document.querySelectorAll(
      '.cat-tile, .product-card, .value-item, .lifestyle-tile'
    );
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(el => {
      el.classList.add('reveal-ready');
      revealObserver.observe(el);
    });
  }

})();
